var path = 'components/settings/tooltips/rulesNetworksNames.html';
var html = "<div ng-repeat=\"name in rule.packageNames\" ng-bind=name></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;